var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "arrow-next",
  "use": "arrow-next-usage",
  "viewBox": "0 0 15 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 28\" id=\"arrow-next\"><path d=\"M2.109.322.639 1.678 12.014 14 .639 26.322l1.47 1.356L14.735 14z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol